import React, { useState, useEffect } from "react";
import { Card, Form, Select} from "antd";
import { Card as BootCard,Button} from "react-bootstrap";
import { QRCodeCanvas } from "qrcode.react";
import html2canvas from "html2canvas";
import { useNavigate } from "react-router-dom";
import WidgetSectionTitle from "widgets/WidgetSectionTitle";
import { APP_LINKS } from "../../../constants";

const PLATFORM_OPTIONS = [
  { value: "ios", label: "iOS Only" },
  { value: "android", label: "Android Only" },
];

export const QRCodeGenerator = () => {
  const [form] = Form.useForm();
  const [qrValue, setQrValue] = useState(APP_LINKS.ios);
  const [qrSize, setQrSize] = useState(256);
    const navigate = useNavigate();
  const handleFormChange = () => {
    const values = form.getFieldsValue();
    const platform = values.platform || "ios";
    const size = values.qrSize || 256;

    setQrValue(APP_LINKS[platform] || APP_LINKS.ios);
    setQrSize(size);
  };

  useEffect(() => {
    handleFormChange();
  }, []);

  const downloadQRCode = () => {
    const container = document.getElementById("qr-code-image-container");
    if (!container) return;

    html2canvas(container, {
      backgroundColor: "#ffffff", 
      scale: 3, 
    }).then((canvas) => {
      const url = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = url;
      link.download = "olitask-qr-code-full.png";
      link.click();
    });
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(qrValue);
    alert("Download link copied!");
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3 mt-3 gap-3">
        <WidgetSectionTitle
          icon="qrcode"
          title="Create QR Code"
          subtitle="Define QR code for Olitask app download"
          className="mb-3 mt-3 flex-1"
        />

        <Button
          variant="info"
          size="sm"
          className="text-sm"
          onClick={() => navigate(-1)}
        >
          Go Back
        </Button>
      </div>

      <div className="container-fluid py-2">
        <div className="row g-3 d-flex align-items-stretch">
          <div className="col-lg-5">
            <Card title="QR Code Configuration" className="custom-shadow">
              <Form
                layout="vertical"
                form={form}
                onValuesChange={handleFormChange}
                initialValues={{ platform: "ios Only", qrSize: 256 }}
                style={{ fontFamily: "Inter" }}
              >
                <Form.Item
                  label="Platform Target"
                  name="platform"
                  rules={[{ required: true }]}
                >
                  <Select options={PLATFORM_OPTIONS} />
                </Form.Item>

                <Form.Item
                  label="QR Code Size (px)"
                  name="qrSize"
                  rules={[{ required: true }]}
                >
                  <Select
                    options={[
                      { value: 128, label: "Small (128px)" },
                      { value: 256, label: "Medium (256px)" },
                      { value: 512, label: "Large (512px)" },
                    ]}
                  />
                </Form.Item>

                <div
                  className="alert alert-info"
                  style={{ fontSize: "0.875rem" }}
                >
                  <strong>Note:</strong> This QR code links to a placeholder app
                  download page (e.g., TestFlight). It will be updated when the
                  app is officially released in stores.
                </div>
              </Form>
            </Card>
          </div>

          <div className="col-lg-7 d-flex justify-content-center">
            <BootCard
              className="custom-shadow flex-fill"
              style={{ maxWidth: 450 }}
            >
              <BootCard.Header
                style={{
                  backgroundColor: "#fff",
                  borderBottom: "1px solid #E2E8F0",
                  fontFamily: "Inter",
                  fontWeight: 600,
                }}
              >
                QR Code Preview
              </BootCard.Header>

              <BootCard.Body
                className="d-flex flex-column align-items-center justify-content-center"
                style={{ padding: 24, textAlign: "center" }}
              >
                {qrValue ? (
                  <>
                    <div
                      id="qr-code-image-container"
                      style={{
                        backgroundColor: "#fff",
                        padding: 24,
                        borderRadius: 8,
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        maxWidth: 400,
                        margin: "0 auto",
                        userSelect: "none",
                      }}
                    >
                      <h4
                        style={{
                          fontWeight: 600,
                          fontFamily: "Inter",
                          marginBottom: 12,
                        }}
                      >
                        Olitask App Download
                      </h4>
                      <p
                        style={{
                          fontSize: "0.9rem",
                          color: "#6c757d",
                          marginBottom: 16,
                        }}
                      >
                        Scan the QR code below to download the Olitask app.
                      </p>

                      <QRCodeCanvas value={qrValue} size={qrSize} level="H" />

                      <code
                        style={{
                          fontSize: "0.75rem",
                          wordBreak: "break-all",
                          backgroundColor: "#f8f9fa",
                          padding: "4px 8px",
                          borderRadius: 4,
                          display: "block",
                          marginTop: 16,
                          userSelect: "text",
                        }}
                      >
                        {qrValue}
                      </code>
                    </div>

                    <div
                      className="d-flex gap-2 mt-3 justify-content-center"
                      style={{ maxWidth: 400 }}
                    >
                      <Button
                        type="primary"
                        size="large"
                        className="bg-success flex-fill"
                        onClick={downloadQRCode}
                      >
                        Download QR Code
                      </Button>

                      <Button size="large" onClick={copyToClipboard}>
                        Copy Link
                      </Button>
                    </div>
                  </>
                ) : (
                  <div
                    className="text-center text-muted"
                    style={{ maxWidth: 400 }}
                  >
                    <div style={{ fontSize: "3rem" }}>📱</div>
                    <p>Scan the QR code to download Olitask app</p>
                  </div>
                )}
              </BootCard.Body>
            </BootCard>
          </div>
        </div>
      </div>
    </>
  );
};
